import jQuery from 'jquery';
window.$ = jQuery;
window.jQuery = jQuery;

window.addEventListener('DOMContentLoaded', function() {
	require('./js-polyfills');
	require('./scroll-smooth');
	require('./swiper');
	require('./plugins/fancybox/jquery.fancybox.min');
	require('./plugins/select2/dist/js/select2.min');
	require('./plugins/select2/dist/js/i18n/ru');
	require('./app');
});